module.exports = __webpack_public_path__ + "media/src/images/partners/pfur-172cd9f9812c85a96c18c66b08cfe5e4.jpg";